enum roles {
    unauthorized,
    admin,
    rep,
}

export default roles;
